import React from "react";
import { Button, makeStyles, mergeClasses, shorthands, tokens } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  button: {
    minWidth: "auto",
    ...shorthands.padding(0),
    ...shorthands.border("none"),
    ...shorthands.borderRadius("4px"),
    ...shorthands.overflow("hidden"),
  },
  flag: {
    display: "block",
    width: "28px",
    height: "20px",
    objectFit: "cover",
    ...shorthands.borderRadius("2px"),
    ...shorthands.border("1px", "solid", tokens.colorNeutralForegroundInverted),
  },
});

type LanguageOption = {
  language: "sv" | "en";
  flag: string;
  label: string;
};

// The switcher is a single toggle that always displays the *other*
// language's flag as the click target, e.g. while browsing in English it
// shows the Swedish flag — clicking switches to Swedish.
const LANGUAGE_OPTIONS: Record<"sv" | "en", LanguageOption> = {
  sv: { language: "en", flag: "/flags/england.svg", label: "Switch to English" },
  en: { language: "sv", flag: "/flags/sweden.svg", label: "Byt till svenska" },
};

type LanguageSwitcherProps = {
  className?: string;
};

export const LanguageSwitcher = ({ className }: LanguageSwitcherProps) => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language?.startsWith("en") ? "en" : "sv";
  const target = LANGUAGE_OPTIONS[currentLanguage];

  return (
    <Button
      appearance="transparent"
      className={mergeClasses(classes.button, className ?? "")}
      onClick={() => i18n.changeLanguage(target.language)}
      aria-label={target.label}
      title={target.label}
    >
      <img className={classes.flag} src={target.flag} alt={target.label} />
    </Button>
  );
};
